import React from 'react';

import Filters from '../../components/Common/Filters/Filters';
import PageLoader from '../../components/Common/loader/PageLoader';
import ValidStoreTable from './Table/ValidStoreTable';

interface Props {
  history: any;
}

interface State {
  isLoading: boolean;
  isFilterApplied: boolean;
  isCallRequired: boolean;
  isTableLoading: boolean;
}

export default class ValidStore extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isFilterApplied: false,
      isCallRequired: false,
      isTableLoading: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isTableLoading !== this.state.isTableLoading) {
      this.setState({ isLoading: this.state.isTableLoading });
    }
  }

  render(): React.ReactNode {
    return (
      <React.Fragment>
        <div className="page-content">

          <PageLoader
            status={this.state.isLoading}
          />

          <Filters
            timeSelection={'single'}
            locationSelection={'multi'}
            productSelection={'multi'}
            history={this.props.history}
            onUpdateFilter={() => {
              this.setState({
                isFilterApplied: true,
                isCallRequired: true,
                isLoading: true,
                isTableLoading: true
              });
            }}
          />

          {
            this.state.isFilterApplied &&
            <ValidStoreTable
              history={this.props.history}
              isCallRequired={this.state.isCallRequired}
              onLoadEnd={() => {
                this.setState({
                  isCallRequired: false,
                  isTableLoading: false
                });
              }}
              onUpdateStart={() => this.setState({ isLoading: true })}
              onUpdateEnd={() => {
                this.setState({
                  isCallRequired: true,
                  isTableLoading: true
                });
              }}
            />
          }

        </div>
      </React.Fragment>
    );
  }
}